module.exports = __webpack_public_path__ + "img/photo-bfs.db83e518.jpg";